import React from "react";
import Link from "next/link";
import { getStockPdpUrl } from "../utils/stockUrlUtils";

export interface ICompany {
  symbol: string;
  name?: string;
  sector?: string | null;
  market_cap?: string | null;
  percentage?: number | null;
  token?: number;
  compName?: string;
  exchId?: string;
  formattedSymbol?: string;
  nseToken?: number;
  bseToken?: number;
  exchange?: number;
}

interface CompanyTagProps {
  company: ICompany;
  className?: string;
}

const CompanyTag: React.FC<CompanyTagProps> = ({ company, className = '' }) => {
  // Handle undefined or null percentage
  const hasPercentage = company.percentage !== undefined && company.percentage !== null;
  const percentage = company.percentage ?? 0;
  const isPositive = percentage >= 0;
  const sign = isPositive ? '+' : '';
  const percentageDisplay = hasPercentage
    ? `${sign}${percentage.toFixed(2)}%`
    : null;

  const stockUrl = getStockPdpUrl(company.symbol);
  const companyDisplayName = (company.compName ?? company.name ?? company.symbol ?? "")
    .replace(/\s+/g, " ")
    .trim();

  return (
    <Link
      href={stockUrl}
      className={`h-6 md:h-7 flex max-w-full items-center gap-2.5 rounded-[20px] border border-[#E5E5E5] bg-white px-2 py-1 transition-colors hover:border-[#FF6700] ${className}`}
      aria-label={`View ${company.symbol} stock details`}
      title={companyDisplayName}
    >
      <span className="font-rubik min-w-0 max-w-12 truncate align-middle text-[12px] font-normal leading-5 tracking-normal text-[#1A1A1A] md:max-w-30 md:text-[14px]">
        {company?.symbol ?? ""}
      </span>
      {percentageDisplay && (
        <span
          className={`font-rubik shrink-0 align-middle text-[12px] font-normal leading-5 tracking-normal md:text-[14px] ${isPositive ? 'text-green-600' : 'text-red-500'
            }`}
        >
          {percentageDisplay}
        </span>
      )}
    </Link>
  );
};

export default CompanyTag;
